<template>
  <div class="footer">
    <div
      class="footer__header flex mw9 center"
      v-if="$route.name !== 'requests' && $route.name !== 'search'"
    >
      <div class="footer__item footer__item--first">
        <p class="ma0">{{$t('cTA')}}</p>
      </div>

      <div class="footer__item footer__item--second">
        <button class="footer__item__link" @click="showPhoneModal">
            <svg
            class="icon"
            width="30px"
            height="25px"
            viewBox="0 0 40 40"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>Phone Icon</title>
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(3.000000, 3.000000)" stroke="#000000" stroke-width="2">
                <path
                  d="M5.13245033,3 C8.08874172,4.51734752 11.784106,9.82806386 11.784106,9.82806386 C8.08874172,12.1040851 7.34966887,14.3801064 9.56688742,16.6561277 L17.6966887,25.0015391 C19.1748344,26.5188866 21.392053,25.0015391 23.6092715,21.2081703 C29.5218543,24.2428653 31,29.5535817 31,29.5535817 C24.3483444,38.6576668 18.4357616,34.1056242 15.4794702,31.829603 C12.5231788,29.5535817 3.21529536,19.5481921 0.698013245,14.3801064 C-2.25827815,8.31071633 5.13245033,3 5.13245033,3 Z"
                ></path>
                <path d="M16,7 C22.4285714,8.53846154 25.2857143,13.1538462 26,17" id="Stroke-3"></path>
                <path d="M18,0 C28.2857143,2.30769231 32.8571429,9.23076923 34,15" id="Stroke-5"></path>
              </g>
            </g>
          </svg>
          <h4 class="text">{{$t('callUs')}}</h4>
        </button>

        <transition name="fade">
          <div
            v-if="isOpen"
            class="footer__item__modal"
            @mouseover="isHovering"
            @mouseleave="notHovering"
            v-on:blur="inputBlur"
          >
            <div class="mt2 mb4">
              <a class="link db" :href="`tel:${localNumber}`">
                <h2 class="title fw4 roboto fs24 mt0 mb0">{{localNumber}}</h2>
                <p class="text ttu fw3 roboto fs14 light-blue mt0 mb0">({{$t('primaryPhoneNumberText')}}<span v-if="isTollFree"> - {{$t('TollFreeText')}}</span>)</p>
              </a>
            </div>

            <div v-if="isPriority" class="mt2 mb3">
              <a class="link db" :href="`tel:+1-${internationalNumber}`">
                <h2 class="title fw4 roboto fs24 mt0 mb0">+1-{{internationalNumber}}</h2>
                <p class="text ttu fw3 roboto fs14 light-blue mt0 mb0">({{$t('secondaryPhoneNumberText')}})</p>
              </a>
            </div>
          </div>
        </transition>
      </div>

      <div class="footer__item footer__item--third">
        <router-link class="footer__item__link flex light-blue" :to="{name: 'requests'}">
          <svg
            class="icon"
            width="30px"
            height="25px"
            viewBox="0 0 40 40"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>Mail Icon</title>
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g transform="translate(0.000000, 5.000000)" stroke="#000000" stroke-width="2">
                <g transform="translate(1.000000, 0.000000)">
                  <polyline
                    points="3.75 11.4148488 3.75 0.000360465116 36 0.000360465116 36 31.0003605 3.75 31.0003605 3.75 27.3957093"
                  ></polyline>
                  <polyline points="36 4.61813488 19.875 20.1181349 3.75 4.61813488"></polyline>
                  <path d="M1.5,20.9069767 L7.5,20.9069767"></path>
                  <path d="M0,24.5116279 L6,24.5116279"></path>
                </g>
                <path d="M10,17.5 L8,17.5"></path>
                <path d="M10,24.5 L8,24.5"></path>
                <path d="M7,17.5 L0,17.5"></path>
                <path d="M7,13.5 L5,13.5"></path>
                <path d="M4,13.5 L2,13.5"></path>
              </g>
            </g>
          </svg>
          <h4
            class="text"
            @click="trackPageClick(`submit_request_link`)"
          >{{$t('submitRequestTitle')}}</h4>
        </router-link>
      </div>
    </div>

    <div class="footer__body relative pt2 pb0">
      <div class="footer__body__inner center relative">
        <div
          v-html="$t('credithcDisclaimer', {siteName: capitalizeSitename, termsLink: termsLink, privacyLink: privacyLink})"
          class="text mw8-l mt3 footer-text lh-copy pb2"
        ></div>

      </div>
      <div class="mb4 ph4">
        <div class="justify-between white row-container footer-lower">
          <div>
            <ul class="list flex pa0 ma3 tracked-l fs-fix footer-links">
              <li>
                <router-link class="link" :to="{name: 'home'}">{{$t('support')}}</router-link>
              </li>
              <li>
                <a class="link" :href="aboutLink">{{$t('aboutLink')}}</a>
              </li>
              <li>
                <router-link class="link" :to="{name: 'requests'}">{{$t('contact')}}</router-link>
              </li>
              <li>
                <a class="link" :href="loginLink">{{$t('loginLinkText')}}</a>
              </li>
            </ul>
          </div>
          <div>
            <p
              v-html="$t('footerCopyright', { siteName: capitalizeSitename, currentYear: currentYear } )"
              class="text fw6 tracked-l tc fs-fix copyright"
            ></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { trackPageClick, capitalize, getCountryCode, available_countries, high_priority_countries, low_priority_countries, ukCreditSites } from '@/utils/common';
// TODO:
export default {
  data() {
    return {
      phoneModalVisible: false,
      isOpen: false,
      hovering: false,
      localNumberText: null,
      isTollFree: false,
      isPriority: false
    };
  },
  created() {
    getCountryCode();
    this.getLocalNumber();
  },
  mounted() {
    this.getDomainName();
  },
  computed: {
    siteName() {
      return this.$store.state.siteDetails.site_name;
    },
    aboutLink() {
      return `https://${this.$store.state.siteDetails.domain_name}/about`;
    },
    contactLink() {
      return `https://www.${this.$store.state.siteDetails.domain_name}/contact`;
    },
    loginLink() {
      return `https://${this.$store.state.siteDetails.domain_name}/login`;
    },
    termsLink() {
      return `https://${this.$store.state.siteDetails.domain_name}/terms`;
    },
    privacyLink() {
      return `https://${this.$store.state.siteDetails.domain_name}/policy`;
    },
    usCanadaNumber() {
      return this.$store.state.siteDetails.support_number_us_canada;
    },
    capitalizeSitename() {
      return capitalize(this.siteName);
    },
    internationalNumber() {
      return this.$store.state.siteDetails.support_number_us_canada;
    },
    localNumber() {
      this.localNumberText = this.getLocalNumber();
      return this.localNumberText;
    },
		currentYear() {
			return new Date().getFullYear();
		}
  },
  methods: {
    trackPageClick,
    showPhoneModal() {
      this.isOpen = !this.isOpen;
    },
    inputBlur() {
      if (!this.hovering) {
        this.isOpen = false;
      }
    },
    isHovering() {
      this.hovering = true;
    },
    notHovering() {
      this.hovering = false;
    },
    getDomainName() {
      return this.$store.state.siteDetails.domain_name;
    },
    getLocalNumber() {
      // getCountryCode();












      let currentSite = this.getDomainName();
      // console.log(`current site is is... ${currentSite}`);
      let localNumber;
      let storedCountryCode = localStorage.getItem('country_code');
      // console.log(`storedCountryCode is... ${storedCountryCode}`);




      const getAvailableCountryList = available_countries;
      // console.log(`getAvailableCountryList is... ${getAvailableCountryList}`);
      const getHighPriorityCountryList = high_priority_countries;
      // console.log(`getHighPriorityCountryList is... ${getHighPriorityCountryList}`);
      const getLowPriorityCountryList = low_priority_countries;
      // console.log(`getLowPriorityCountryList is... ${getLowPriorityCountryList}`);
      const ukCreditSitesArray = ukCreditSites;
      // console.log(`ukCreditSitesArray is... ${ukCreditSitesArray}`);




      // If gb corp... display 'uk toll-free shippable number'
      if( ukCreditSitesArray.indexOf(currentSite) > -1 ) {
        // console.log(`Yes`);
        this.isTollFree = true;
        localNumber = this.$store.state.siteDetails.corp_info.uk_toll_free_number_shippable;
        localStorage.setItem('local_number', localNumber);
        return localNumber;

      // else if us corp... display 'us toll-free shippable number'
      } else {
        // console.log(`No`);
        this.isTollFree = true;
        localNumber = this.$store.state.siteDetails.corp_info.us_toll_free_number_shippable;
        localStorage.setItem('local_number', localNumber);
        return localNumber;
      }




      // If gb... display 'uk toll-free shippable number'
      // if(storedCountryCode === "gb") {
      //   this.isTollFree = true;
      //   localNumber = this.$store.state.siteDetails.corp_info.uk_toll_free_number_shippable;
      //   localStorage.setItem('local_number', localNumber);
      //   return localNumber;

      // // InFuture...if is/ca... display 'us toll-free shippable number'
      // } else if (storedCountryCode === "us" || storedCountryCode === "ca") {
      //   this.isTollFree = true;
      //   // localNumber = this.$store.state.siteDetails.corp_info[`${storedCountryCode}_toll_free_number_shippable`];
      //   localNumber = this.$store.state.siteDetails.corp_info.uk_toll_free_number_shippable;
      //     localStorage.setItem('local_number', localNumber);
      //     return localNumber;

      // // Otherwise, display 'default' (currently 'uk toll-free shippable number') for all others
      // } else {
      //   localNumber = this.$store.state.siteDetails.corp_info.uk_toll_free_number_shippable;
      //     localStorage.setItem('local_number', localNumber);
      //     return localNumber;
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.roboto {
  font-family: Roboto, Helvetica, Arial, sans-serif;
}
.fs24 {
  font-size: 24px;
}
.fs14 {
  font-size: 14px;
}
.footer {
  margin-top: 3rem;
  h2 {
    font-family: Roboto, Helvetica, Arial, sans-serif;
  }
}
.light-blue {
  color: #99d8f7;
}

.footer__header {
  background: #ddd;
  border-color: #b4b4b4;
  border-width: 1px 0;
  border-style: solid;
  padding: 0% 10% 0% 10%;
  height: 80px;
  margin: 0 auto;
}
.footer__item {
  font-family: Roboto, Helvetica, Arial, sans-serif;
  text-align: center;
  margin: 0;
  padding: 1rem;
  display: flex;
  align-items: center;
  justify-content: center;
  h4 {
    font-family: Roboto, Helvetica, Arial, sans-serif;
  }
}
.footer__item--first {
  display: none;
  flex: 1;
}
.footer__item--second {
  position: relative;
}
.footer__item--third {
  flex: 1;
}

.footer__item__link {
  color: $theme-highlight;
  font-weight: 600;
  text-transform: uppercase;
  justify-content: center;
  align-items: baseline;
  display: flex;
  text-decoration: none;
  width: 100%;
  -webkit-appearance: none;
  background: transparent;
  border: 0;
  cursor: pointer;
  text-align: left;

  .text {
    font-weight: 600;
  }

  .icon {
    // margin-right: 0.5em;
    margin-right: 5px;

    polyline,
    path {
      stroke: $theme-highlight;
    }
  }
  .text {
    margin: 0;
  }
}

.footer__body {
  background: #2a2a2a;
  padding: 1rem 0;
  line-height: 1rem;
  min-height: 180px;

  .list {
    font-size: 1.15rem;
    li {
      margin-right: 16px;
      .link {
        color: #fff;
        font-weight: 600;
      }
      .link:hover {
        color: lightgray;
        font-weight: 600;
      }
    }
  }
}
.footer__body__inner {
  max-width: 50rem;

  .text {
    font-size: 0.9em;
    color: #676767;
  }
  .link {
    color: $theme-highlight;
    text-decoration: underline;
  }
}
.footer__item__modal {
  position: absolute;
  background: #fff;
  // padding: 1rem;
  padding: 8px 8px 8px 8px;
  width: 320px;
  border: 1px solid #000;
  border-radius: 6px;
  left: 90%;
  transform: translateX(-50%);
  bottom: 73%;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
  }
  .link {
    color: $theme-highlight;
  }
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.powered-by-zendesk {
  font-size: 13px;
  font-family: Helvetica, Arial, sans-serif;
  color: #fff;
  width: auto !important;
  clear: both;
  text-align: right;
  padding: 0px 15px;
}
.powered-by-zendesk a {
  color: #fff;
  text-decoration: none;
}

.powered-by-zendesk svg {
  position: relative;
  display: inline-block;
  top: 3px;
  content: ' ';
  width: 15px;
  height: 15px;
  margin-right: 5px;
  fill: #a5a5a5;
}
.fs-fix {
  font-size: 13.6px !important;
}
.copyright {
  margin-right: 15px;
}

@media (min-width: 641px) {
  .footer__header {
    padding: 0% 10% 0% 10%;
    max-width: none;

    .footer__item {
      padding: 0 0.5rem;
    }
  }
  .footer__item--first {
    display: flex;
  }
}
@media (max-width: 375px) {
  .footer__body {
    padding: 1rem 1rem 4rem 1rem;
    .list li {
      padding-top: 10px;
    }
  }
  .footer__body__inner {
    justify-content: center;
  }
  .copyright {
    margin-top: 40px;
    margin-right: 0px;
  }
  .tracked-l {
    letter-spacing: 0.1em;
  }
  .powered-by-zendesk {
    position: relative;
    top: 45px;
  }

  .ma3 {
    flex-wrap: wrap;
    padding: 8px;
    margin-top: 5px;
  }
}
@media (max-width: 425px) {
  .footer__body__inner {
    justify-content: center;
  }
  .copyright {
    margin-top: 30px;
    margin-right: 0px;
    padding: 0px 5px 20px 5px;
  }
  .tracked-l {
    letter-spacing: 0.1em;
  }
  .powered-by-zendesk {
    position: relative;
    top: 45px;
    padding-right: 0;
  }
  .ph4 {
    padding-left: 0;
    padding-right: 0;
  }
  .footer__item {
    padding: 0;
  }
  .footer__item--second {
    flex: 1;
  }
}

@media (max-width: 830px) {
  .footer-links {
    justify-content: center;
  }
}
@media (min-width: 830px) {
  .footer-lower {
    display: flex;
  }
}
@media (min-width: 375px) and (max-width: 768px) {
  .footer-text {
    padding-left: 16px;
    padding-right: 16px;
  }
}
@media (min-width: 375px) and (max-width: 425px) {
  .powered-by-zendesk {
    top: 0;
    padding: 0px 15px;
  }
}
@media (min-width: 768px) {
  .footer {
    margin-top: 1rem;
  }
  .footer__body__inner {
    justify-content: center;
    width: 450px;
  }
  .footer__body {
    text-align: justify;
  }
  .copyright {
    margin: 35px 0 65px 0px;
    letter-spacing: 0.1em;
  }
  .footer__body ul {
    justify-content: center;
  }
}
@media (min-width: 1024px) {
  .footer__body__inner {
    justify-content: center;
    width: 750px;
  }
  .footer__body {
    text-align: justify;
  }
  .copyright {
    margin-top: 17px;
    margin-bottom: 0px;
    margin-right: 0px;
  }
}
</style>
